import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaPessoaCampanhaMudas } from '../../components/TabelaPessoaCampanhaMudas';

export default function PessoaCampanhaMudasPage() {

    return (
        <>           
            <MenuMain >
                <TabelaPessoaCampanhaMudas />
            </MenuMain>
            <AppFooter />    
        </>
    );
}
